import * as React from "react";
// @ts-ignore 1706
import { Textfit } from "react-textfit";
import ReactMinimalPieChart from "webapp/ui/smart/charts/minimal-chart/Chart";
import { ChartTitleContainer } from "webapp/ui/smart/charts/chart-legend/chart-legend-style";
import { TotalSubtitle } from "webapp/ui/smart/charts/pie-chart/pie-chart-style";
import { withTheme } from "styled-components";
import type { RuntimeTheme } from "webapp/lib/theme/theme";
import { CircleProgressStyle, HalfCircleProgressCenter } from "../circle-progress/circle-progress-view-style";
import ChartLegend from "webapp/ui/smart/charts/chart-legend/chart-legend";
import type { ProgressProps } from "../progress-indicator-types";
import classNames from "classnames";
import { browserIsSafari } from "lib/browser-detect";

interface Props extends ProgressProps {
    readonly theme: RuntimeTheme;
}
interface State {
    readonly showEllipsis: boolean;
}

class HalfCircleProgressImpl extends React.PureComponent<Props, State> {
    public state: State = { showEllipsis: false };

    private injectEllipsis = () => {
        if (!this.state.showEllipsis) {
            this.setState({ showEllipsis: true });
        }
    };

    public componentDidMount() {
        setTimeout(() => {
            this.setState({ showEllipsis: false });
        }, 200);
    }

    private textFitStyle: React.CSSProperties = { overflow: "hidden" };

    public render(): React.ReactNode {
        let { value } = this.props;
        const { minimum, maximum, title, caption, theme, showTotal, formatted } = this.props;

        const ellipsisStyle = this.state.showEllipsis
            ? {
                  textOverflow: "ellipsis",
              }
            : undefined;

        value = Math.max(minimum, Math.min(maximum, value));
        const progress = Math.round(Math.max(0, Math.min(100, (100 * (value - minimum)) / (maximum - minimum))));

        return (
            <CircleProgressStyle className="half-circle ">
                <ChartTitleContainer isCentered={true}>
                    <div className="chart-title">{title}</div>
                </ChartTitleContainer>
                <div className={classNames("circle-progress-container")}>
                    {showTotal && (
                        <HalfCircleProgressCenter>
                            <Textfit
                                mode="single"
                                forceSingleModeWidth={true}
                                min={12}
                                max={34}
                                onReady={this.injectEllipsis}
                                style={this.state.showEllipsis && this.textFitStyle}>
                                <div className="total-value fit-title" style={ellipsisStyle}>
                                    {progress}%
                                </div>
                            </Textfit>

                            <Textfit
                                mode="single"
                                forceSingleModeWidth={true}
                                min={10}
                                max={17}
                                onReady={this.injectEllipsis}
                                style={this.state.showEllipsis && this.textFitStyle}>
                                <TotalSubtitle className="fit-subtitle" style={ellipsisStyle}>
                                    {formatted}
                                </TotalSubtitle>
                            </Textfit>
                        </HalfCircleProgressCenter>
                    )}
                    <ReactMinimalPieChart
                        style={{ transform: "scaleX(-1)" }}
                        animate={browserIsSafari ? true : false}
                        animationDuration={20}
                        ratio={1.82}
                        cx={50}
                        cy={50}
                        totalValue={maximum}
                        data={[
                            {
                                value: maximum - value,
                                title: "",
                                color: theme.separatorColor,
                                displayValue: (maximum - value).toString,
                            },
                            {
                                value,
                                title: "Value",
                                color: theme.primaryAccentColor,
                                displayValue: value.toString,
                            },
                        ]}
                        startAngle={180}
                        lengthAngle={180}
                        lineWidth={20}
                        paddingAngle={0}
                        radius={50}
                        rounded={true}
                        label={false}
                    />
                </div>

                <ChartLegend showDetails={true} caption={caption} />
            </CircleProgressStyle>
        );
    }
}

const HalfCircleProgressView = withTheme(HalfCircleProgressImpl);
export default HalfCircleProgressView;
